export const environment = {
  title: 'staging',
  production: false,
  apiUrl: 'https://api-aorta.staging.edgardcooper.com/v1',
  resellerUrl: 'https://reseller.staging.edgardcooper.com',
};
